import moment from 'moment';
import validator from 'validator';
import * as formUtils from './formUtils'
import * as dateUtils from './dateUtils'
import * as commontUtils from './commonUtils'

export const
STEP_PROCESS = 'process',
STEP_WAIT = 'wait',
STEP_FINISH = 'finish',
STEP_ERROR = 'error',
EXCLUDE_FIELD = 'This field is not required';

export function updateValidationState(storeForm, config, prevProps, props, validateOnlyWhenPopulated) {
    const { key, parentKey } = config;
  

    // old object can be empty
    if(prevProps) {
        let
        oldObj = prevProps[key],
        currentObj = props[key];

        if(!commontUtils.simpleObjectCompare(oldObj, currentObj)) {
            let formState = validateForm(currentObj, config, validateOnlyWhenPopulated);
            if(config.parentKey) storeForm(parentKey, key, formState)
            else storeForm(key, formState);
        }
    }
}

export function validateForm(form, formConfig, validateOnlyWhenPopulated) {
    let returnVal = {};
   

    // only apply validation help when the field is populated
    const validateWhenPopulated = !!validateWhenPopulated;

    Object.keys(formConfig.formItems).map(key => {
        const { type } = formConfig.formItems[key];

        // handle init date fields
        let defaultDate;
        if(type === formUtils.DATE_PICKER && !form[key]) defaultDate = dateUtils.defaultBirthDateMoment();

        // if help is set to exclude, then skip field
        if(form[`${key}${formUtils.HELP_SUFFIX}`] === EXCLUDE_FIELD) returnVal = {...returnVal};
        else returnVal = {...returnVal, ...validateField(
            key,
            defaultDate ? undefined : form[key],
            formConfig.formItems[key],
            validateOnlyWhenPopulated
        )};
    });

    return returnVal;
}

export function validateField(fieldName, fieldValue, fieldConfig, validateOnlyWhenPopulated) {
    let
    validateStatus = VALID_STATUS,
    help = [];
   
    
    const { type } = fieldConfig;

    fieldConfig.rules.forEach(rule => {
        if(type === formUtils.DATE_PICKER && !fieldValue) fieldValue = undefined;
        else fieldValue = !fieldValue ? '' : fieldValue;

        // allows for behavior where validation is only appliend once a field is populated,
        // candidate kind of pre validates everything, because the expectation is that things
        // are mostly populated
        const isPopulated = !!fieldValue;
        let result = rule(fieldValue);

        if(result && !result.valid) {
            // if not populated, and flag not set or is populated then applyValidtion normal
            // validation
            if((!isPopulated && !validateOnlyWhenPopulated) || isPopulated) {
                help.push(result.help);
                validateStatus = ERROR_STATUS;
            } else {
              //if a field is not set and is required the state is not valid, but we don't want a message
              if(!fieldConfig.optional && !isPopulated){
                validateStatus = NOT_SET;
              }
            }
        }
    });

    return {
        [fieldName]: fieldValue,
        [`${fieldName}${formUtils.HELP_SUFFIX}`]: help.join('. '),
        [`${fieldName}${formUtils.STATUS_SUFFIX}`]: validateStatus
    }
}

export function validateSubForm(form, optionalExcludesArray) {
    let isValid = true;
    if(form)
        Object.keys(form).map(key => {
            // if excludes are defined, skip matches
            if(!optionalExcludesArray || (optionalExcludesArray && !optionalExcludesArray.some(element => key.startsWith(element))))
                if(key.endsWith(formUtils.STATUS_SUFFIX))
                    if(form[key] !== VALID_STATUS && form[key]!=='')
                        isValid = false;
        });

    return isValid;
}

export function sanatizeForm(form) {
    let result = {};

    Object.keys(form).map(function(key) {
        if(key.endsWith(formUtils.STATUS_SUFFIX) || key.endsWith(formUtils.HELP_SUFFIX)) {
            // noop
        } else result[key] = form[key];
    });

    return result;
}

export function stepValidation(validationStatus) {
    return validationStatus ? STEP_FINISH : STEP_ERROR;
}

function isIgnoredField(key) {
    return key !== 'id' & !(key.includes('Date')) &&
        !(key.includes(formUtils.HELP_SUFFIX)) &&
        !(key.includes(formUtils.STATUS_SUFFIX));
}

export function isFormPopulated(form) {
    return form
        // ignore validtion fields and dates
        ? Object.keys(form).some(key => form[key] && isIgnoredField(key))
        : false;
}



const
VALID = { valid: true },
ERROR_STATUS = 'error',
VALID_STATUS = 'success',
NOT_SET = 'required',
NO_OP = () => {},
NO_OP_VALID = () => VALID,
NO_OP_INVALID = () => getError('An unexpected error has occured.'),
MESSAGES = {
    REQUIRED_MESSAGE: 'Required Field',
    ALPHABETIC_MESSAGE: 'Enter only letters',
    ALPHABETIC_SPECIALNAME_MESSAGE: 'Enter only letters and some special characters , . - ` \'',
    ALPHANUMERIC_SPECIALNAME_MESSAGE: 'Enter only letters, numbers, and allowable special characters', 
    ALPHANUMERIC_MESSAGE: 'Enter only letters or numbers',
    STREET_ADDRESS_MESSAGE: 'Enter only letters, numbers, and allowable special characters',
    ALPHANUMERIC_DASH_MESSAGE: 'Enter only letters, numbers, dash (-), and (space)',
    ALPHANUMERIC_SPACES_MESSAGE: 'Enter only letters, numbers or allowable character(s)',
    ALPHANUMERIC_SPACES_UNDERSCORE_DASH: 'Enter only letters, numbers, underscore (_), dash (-), or (space))',
    ALPHANUMERIC_SPACES_AND_SPECIAL_MESSAGE: special => `Only English alphabetic, spaces and some special characters (i.e ${special})`,
    USER_ID_MESSAGE: 'Enter only letters, numbers, or underscore (_). Must be 4 to 50 characters long',
    PIV_ID_MESSAGE: 'PIV value must be a 10 digit PIV identifier, followed by a period (.), followed by CAPITALIZED agency ID',
    NUMERIC_MESSAGE: 'Enter only numbers',
    EMAIL_MESSAGE: 'Must be an email',
    CREDIT_CARD_NUMBER_MESSGAGE: 'Not a valid Credit Card Number',
    PHONE_NUMBER_MESSAGE: 'Must be a phone number',
    INVALID_EXTENSION_MESSAGE: 'At least 5 digits must precede x',
    IN_PAST_MESSAGE: 'Should be in the past',
    IN_FUTURE_MESSAGE: 'Must be in the future',
    GOV_EMAIL_MESSAGE: 'Must be a .gov or .mil email address',
    FAA_EMAIL_MESSAGE: 'Must be a faa.gov email address',
    CHRONOLOGICAL_MESSAGE: 'End date must come after start date',
    MIN_DATE_MESSAGE: 'The date selected comes before the minimum date allowed for this entry',
    MAX_DATE_MESSAGE: 'The date selected comes after the maximum date allowed for this entry',
    MIN_MAX_DATE_MESSAGE: 'Age must be between 5 and 100 years',
    EXPIRED_MESSAGE: 'Document marked Current is expired',
    HAS_ALPHANUMERIC_AND_SPECIAL_MESSAGE: 'Requires alphanumeric and special characters',
    HAS_ALPHANUMERIC_MESSAGE: 'Requires alphanumeric characters',
    HAS_SPECIAL_MESSAGE: 'Requires special characters',
    LOWERCASE_ALPHANUMERIC_MESSAGE: 'Enter only lowercase letters and/or numbers',
    INVALID_MIN_LENGTH_DIGIT_MESSAGE: length => `Must have ${length} or more digits`,
    INVALID_MIN_PHONE_LENGTH_MESSAGE: length => `Must have ${length} or more digits`,
    INVALID_MIN_LENGTH_CHAR_MESSAGE: length => `Must have ${length} or more characters`,
    INVALID_MAX_LENGTH_MESSAGE: length => `Exceeds ${length} characters`,
    HAS_MIN_CHARACTERS_MESSAGE: (amount, chars) => `Should have at least ${amount} characters (${chars.split('').join(' ')})`,
    HAS_MAX_CHARACTERS_MESSAGE: (amount, chars) => `Should not have more than ${amount} characters (${chars.split('').join(' ')})`
    , CONDITIONAL_RECEIPT_NUMBER_REQUIRED_MESSAGE: 'Required if no Applicant Number'
},
getError = msg => ({ help: msg, valid: false, validateStatus: 'error' });

var
startDate = null,
endDate = null,
condition = false;

export const
linkedFields = (form, config, links) => {
    if (form != null && config != null && links != null)
        for(let i in links) config = {...links[i](form, config)};
    return config;
},
validationUtils = {
    isRequiredOnCondition: (field, target, condition) => (form, config) => {
        const
        { isRequired } = validationRules,
        buildNewRules = (operation, rules) => {
            switch(operation) {
                case 'add': return (r => {
                    let newRules = [ isRequired ];
                    for(let i in r) newRules.push(r[i]);
                    return [...newRules];
                })(rules);

                case 'do_nothing': return [...rules];

                case 'remove_conditional_rules': return (r => {
                    let newRules = [ ];
                    for (let i in r) {
                        console.log(r[i]);
                        console.log(r[i].name);
                        if (! (r[i].name.startsWith('conditional_'))) {
                            newRules.push(r[i]);
                        }
                    }
                    return [...newRules];
                })(rules);
            }
        };

        let _condition = condition(form[target]);
        if (_condition) {
            if (config.key === 'i797Form') {
                if ((field === 'RECEIPT_NUMBER' && target === 'idNumber') || (field === 'expirationDate' && target === 'durationOfStatus')) {
                    return {...config, formItems: {...config.formItems,
                        [field]: {...config.formItems[field],
                            rules: buildNewRules('do_nothing', config.formItems[field].rules),
                            optional: false
                        }
                    }}
                }
            }
            return {...config, formItems: {...config.formItems,
                [field]: {...config.formItems[field],
                    rules: buildNewRules('add', config.formItems[field].rules),
                    optional: false
                }
            }}
        }
        else {
            if (config.key === 'i797Form') {
                if ((field === 'RECEIPT_NUMBER' && target === 'idNumber') || (field === 'expirationDate' && target === 'durationOfStatus')) {
                    return {...config, formItems: {...config.formItems,
                        [field]: {...config.formItems[field],
                            rules: buildNewRules('remove_conditional_rules', config.formItems[field].rules),
                            optional: true
                        }
                    }}
                }
            }
            return {...config, formItems: {...config.formItems,
                [field]: {...config.formItems[field],
                    rules: buildNewRules('do_nothing', config.formItems[field].rules),
                    optional: true
                }
            }}
        }
    }
},
validationRules = {
    isCondition: data => {
        condition = data;
    },
    isRequired: data => {
        const { REQUIRED_MESSAGE } = MESSAGES;
        return Array.isArray(data)
            ? data.length > 0 ? VALID : getError(REQUIRED_MESSAGE)
            : data ? VALID : getError(REQUIRED_MESSAGE);
    },
    conditional_isRequired: data => {
        const { REQUIRED_MESSAGE } = MESSAGES;
//if (! condition) {
        return Array.isArray(data)
            ? data.length > 0 ? VALID : getError(REQUIRED_MESSAGE)
            : data ? VALID : getError(REQUIRED_MESSAGE);
//}
    },
    conditional_isRequired_withCustomMessage: customMsg => data => {
        return Array.isArray(data)
            ? data.length > 0 ? VALID : getError(customMsg)
            : data ? VALID : getError(customMsg);
    },
    conditional_isRequired_receiptNumber: data => {
        const { CONDITIONAL_RECEIPT_NUMBER_REQUIRED_MESSAGE } = MESSAGES;
        return data.length > 0 ? VALID : getError(CONDITIONAL_RECEIPT_NUMBER_REQUIRED_MESSAGE);
    },

    ///////////////////////////////////////////////////////////////
    // If this is not being used anywhere, it should be removed. //
    // isConditionalRequired: data => {                          //
    //     if (!condition) {                                     //
    //         const { REQUIRED_MESSAGE } = MESSAGES;            //
    //         return data ? VALID : getError(REQUIRED_MESSAGE); //
    //     }                                                     //
    // },                                                        /
    /////////////////////////////////////////////////////////////

    isUserID: data => {
      const { USER_ID_MESSAGE } = MESSAGES;
      return validator.matches(data, /^[a-z0-9_]{4,50}$/i) ? VALID : getError(USER_ID_MESSAGE);
    },
    isPivID: data => {
      const { PIV_ID_MESSAGE } = MESSAGES;
      return validator.matches(data, /^[0-9]{10}[\.][A-Z]{3}$/i) ? VALID : getError(PIV_ID_MESSAGE);
    },
    isName: data => {
        const { ALPHABETIC_MESSAGE } = MESSAGES;
        return validator.matches(data, /^[a-z \.\,\'\`\-]*$/i) ? VALID : getError(ALPHABETIC_MESSAGE);
    },
    isNameWithOneCharValidation: data => {
        const { ALPHABETIC_SPECIALNAME_MESSAGE } = MESSAGES;
        if (data.length == 1) {
            return (validator.matches(data, /^[a-z \-]*$/i) && !validator.matches(data, /^\s+/)) ? VALID : getError(ALPHABETIC_SPECIALNAME_MESSAGE);
        }
        return (validator.matches(data, /^[a-z \.\,\'\`\-]*$/i) && !validator.matches(data, /^\s+/)) ? VALID : getError(ALPHABETIC_SPECIALNAME_MESSAGE);
    },
    isCreditCardNumber: data => {
        const { CREDIT_CARD_NUMBER_MESSGAGE } = MESSAGES;
        return validator.isCreditCard(data) ? VALID : getError(CREDIT_CARD_NUMBER_MESSGAGE);
    },
    isAlphabetic: data => {
        const { ALPHABETIC_MESSAGE } = MESSAGES;
        validator.isAlpha(data, 'en-US') ? VALID : getError(ALPHABETIC_MESSAGE);
    },
    isAlphanumeric: data => {
        const { ALPHANUMERIC_MESSAGE } = MESSAGES;
        return validator.isAlphanumeric(data, 'en-US') ? VALID : getError(ALPHANUMERIC_MESSAGE);
    },
    isLowercaseAlphanumeric: data => {
        const { LOWERCASE_ALPHANUMERIC_MESSAGE } = MESSAGES;
        return validator.matches(data, /^[a-z0-9]*$/) ? VALID : getError(LOWERCASE_ALPHANUMERIC_MESSAGE);
    },
    isNumeric: data => {
        const { NUMERIC_MESSAGE } = MESSAGES;
        return (validator.isNumeric(data, {no_symbols:true})||(data==='')) ? VALID : getError(NUMERIC_MESSAGE);
    },
    isStreetAddress: data => {
        const { STREET_ADDRESS_MESSAGE } = MESSAGES;
        return validator.matches(data, /^[a-z0-9][ -~]*$/i) ? VALID : getError(STREET_ADDRESS_MESSAGE);
    },
    isAlphaNumASCII: data => {
        const { ALPHANUMERIC_SPECIALNAME_MESSAGE } = MESSAGES;
        return validator.matches(data, /^[a-z0-9][ -~]*$/i) ? VALID : getError(ALPHANUMERIC_SPECIALNAME_MESSAGE);
    },
    isAlphanumericWithDash: data => {
        const { ALPHANUMERIC_DASH_MESSAGE } = MESSAGES;
        return validator.matches(data, /^[a-z0-9 -]*$/i) ? VALID : getError(ALPHANUMERIC_DASH_MESSAGE);
    },
    isAlphanumericWithSpacesDashesAndUnderscore: data => {
        const { ALPHANUMERIC_SPACES_UNDERSCORE_DASH } = MESSAGES;
        return validator.matches(data, /^[a-zA-Z1-9_\s-]*$/i) ? VALID : getError(ALPHANUMERIC_SPACES_UNDERSCORE_DASH);
    },
    isAlphanumericWithSpaces: data => {
        const { ALPHANUMERIC_SPACES_MESSAGE } = MESSAGES;
        return validator.matches(data, /^[a-z0-9\s]*$/i) ? VALID : getError(ALPHANUMERIC_SPACES_MESSAGE);
    },
    isAlphaWithSpacesAndSpecial: special => data => {
        const { ALPHANUMERIC_SPACES_AND_SPECIAL_MESSAGE } = MESSAGES;
        return validator.matches(data, `^[a-zA-Z\\s${special}]*$`) ? VALID : getError(ALPHANUMERIC_SPACES_AND_SPECIAL_MESSAGE(special));
    },
    isEmail: data => {
            const { EMAIL_MESSAGE } = MESSAGES;
            return validator.isEmail(data) ? VALID : getError(EMAIL_MESSAGE);
    },
    isMultipleEmails: data => {
        const { EMAIL_MESSAGE } = MESSAGES;
        if (data.includes(';')) {
                var email = [];
                email = data.trim().split(';');
            for (let i = 0; i < email.length; i++) {
                if (!validator.isEmail(email[i].trim()) && email[i] != "" && email[i] != " ") {
                    return getError(EMAIL_MESSAGE);
                }
            }
            return VALID;
        } else {
            return validator.isEmail(data) ? VALID : getError(EMAIL_MESSAGE);
        }
    },
    isConditionalEmail: data => {
        if (!condition) {
            const { EMAIL_MESSAGE } = MESSAGES;
            return validator.isEmail(data) ? VALID : getError(EMAIL_MESSAGE);
        }
    },
    isPhone: data => {
        const { PHONE_NUMBER_MESSAGE } = MESSAGES;
        return !validator.matches(data.trim(), /^[+]?[0-9\-\(\)x\s]+$/im) ? getError(PHONE_NUMBER_MESSAGE) : VALID;
    },
    extensionValidation: data => {
        const { INVALID_EXTENSION_MESSAGE } = MESSAGES;
        if (data.includes('x')) {
            return !validator.matches(data, /(\D*\d){5}x/) ? getError(INVALID_EXTENSION_MESSAGE) : VALID;
        } else {
            return false;
        }
    },
    isGov: data => {
        const { GOV_EMAIL_MESSAGE } = MESSAGES;
        return !(data.endsWith('mil') || data.endsWith('gov')) ? getError(GOV_EMAIL_MESSAGE) : VALID;
    },
    isFaa: data => {
        const { FAA_EMAIL_MESSAGE } = MESSAGES;
        return !(data.toLowerCase().endsWith('faa.gov')) ? getError(FAA_EMAIL_MESSAGE) : VALID;
    },
    isConditionalPhone: data => {
        if (!condition) {
            const { PHONE_NUMBER_MESSAGE } = MESSAGES;
            return !validator.matches(data, /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4,6}$/im)
                ? getError(PHONE_NUMBER_MESSAGE)
                : VALID;
        }
    },
    isPast: data => {
        const { IN_PAST_MESSAGE } = MESSAGES;

        var
        now = moment.utc().startOf('day'),
        date = moment.utc(data);

        return now < date ? getError(IN_PAST_MESSAGE) : VALID;
    },
    isFuture: data => {
        const { IN_FUTURE_MESSAGE } = MESSAGES;

        var
        now = moment.utc().endOf('day'),
        date = moment.utc(data);

        return now > date ? getError(IN_FUTURE_MESSAGE) : VALID;
    },
    isChronologicalStart: data => {
        const { CHRONOLOGICAL_MESSAGE } = MESSAGES;
        startDate = moment.utc(data);
        console.log("DATES: ", startDate, endDate);
        return endDate != null && moment.utc(data) > endDate ? (endDate._i != undefined ? getError(CHRONOLOGICAL_MESSAGE) : VALID) : VALID;
    },
    isChronologicalEnd: data => {
        const { CHRONOLOGICAL_MESSAGE } = MESSAGES;
        endDate = moment.utc(data);
        return startDate !=null  && startDate > endDate ? (startDate._i != undefined ? getError(CHRONOLOGICAL_MESSAGE) : VALID) : VALID;
    },
    isMinBirthDate: data => {
        if(data) {
            const { MIN_DATE_MESSAGE } = MESSAGES;

            let
            minAllowed = dateUtils.defaultBirthDateMoment(),
            date = moment.utc( data );

            if(minAllowed < date) return getError(MIN_DATE_MESSAGE);
        }
        return VALID;
    },
    isMinMaxBirthDate: data => {
        if(data) {
            const { MIN_MAX_DATE_MESSAGE } = MESSAGES;

            let
            minAllowed = dateUtils.defaultBirthMinMoment(),
            maxAllowed = dateUtils.defaultBirthMaxMoment(),
            date = moment.utc( data );

            if(minAllowed < date  || maxAllowed>date) return getError(MIN_MAX_DATE_MESSAGE);
        }
        return VALID;
    },
    isMinDate: data => {
        const { MIN_DATE_MESSAGE } = MESSAGES;

        let
        now = moment.utc().unix(),
        date = moment.utc(data).unix();

        return (now + 345600) > date ? getError(MIN_DATE_MESSAGE) : VALID;
    },
    isMinDateFiveDays: data => {
        const { MIN_DATE_MESSAGE } = MESSAGES;

        let
        now = moment.utc().unix(),
        date = moment.utc(data).unix();

        return (now + 432000) > date ? getError(MIN_DATE_MESSAGE) : VALID;
    },
    isMaxDate: data => {
        const { MAX_DATE_MESSAGE } = MESSAGES;

        let
        now = moment.utc().unix(),
        date = moment.utc(data).unix();

        return (now + 63072000) < date ? getError(MAX_DATE_MESSAGE) : VALID;
    },
    isNotExpired: data => {
        const { EXPIRED_MESSAGE } = MESSAGES;
        let now = moment.utc();
        return (now > endDate) && validator.matches(data, 'CURRENT') ? getError(EXPIRED_MESSAGE) : VALID;
    },
    isMinLength: length => data => {
        const { INVALID_MIN_LENGTH_CHAR_MESSAGE } = MESSAGES;
        return data.length >= length ? VALID : getError(INVALID_MIN_LENGTH_CHAR_MESSAGE(length));
    },
    isMinLengthWith5Digits: length => data => {
        const { INVALID_MIN_LENGTH_DIGIT_MESSAGE } = MESSAGES;
        return ((data.length >= length) && validator.matches(data, /(.*[0-9]){5}/i)) ? VALID : getError(INVALID_MIN_LENGTH_DIGIT_MESSAGE(length));
    },
    isMaxLength: length => data => {
        const { INVALID_MAX_LENGTH_MESSAGE } = MESSAGES;
        return data.length <= length ? VALID : getError(INVALID_MAX_LENGTH_MESSAGE(length));
    },
    hasAlphanumericAndSpecial: data => {
        const { HAS_ALPHANUMERIC_AND_SPECIAL_MESSAGE } = MESSAGES;
        return /[A-Za-z0-9~`!#$@%\^&*+=\-\[\]\\';,]/g.test(data) ? VALID : getError(HAS_ALPHANUMERIC_AND_SPECIAL_MESSAGE);
    },
    hasAlphanumeric: data => {
        const { HAS_ALPHANUMERIC_MESSAGE } = MESSAGES;
        return /[a-z0-9]/gi.test(data) ? VALID : getError(HAS_ALPHANUMERIC_MESSAGE);
    },
    hasSpecialCharacters: data => {
        const { HAS_SPECIAL_MESSAGE } = MESSAGES;
        // return /[~`!#$@%\^&*+=\-\[\]\\';,]/g.test(data) ? VALID : getError(HAS_SPECIAL_MESSAGE);
        return /[^a-zA-Z0-9]/g.test(data) ? VALID : getError(HAS_SPECIAL_MESSAGE);
    },
    hasNumericCharacter: data => {
        const { HAS_NUMERIC_MESSAGE } = MESSAGES;
        return /[0-9]/g.test(data) ? VALID : getError(HAS_NUMERIC_MESSAGE);
    },
    hasUpperCharacter: data => {
        const { HAS_UPPER_MESSAGE } = MESSAGES;
        return /[A-Z]/g.test(data) ? VALID : getError(HAS_UPPER_MESSAGE);
    },
    hasLowerCharacter: data => {
        const { HAS_LOWER_MESSAGE } = MESSAGES;
        return /[a-z]/g.test(data) ? VALID : getError(HAS_LOWER_MESSAGE);
    },
    hasMinCharacters: (amount, charList) => data => {
        const { HAS_MIN_CHARACTERS_MESSAGE } = MESSAGES;
        let ttl = 0, chars = charList.split('').map(c => ({ _char: c, count: 0 }));

        for(let c in chars) {
            chars[c].count = data.split(chars[c]._char).length - 1;
            ttl += chars[c].count;
        }

        return ttl >= amount ? VALID : getError(HAS_MIN_CHARACTERS_MESSAGE(amount, charList));
    },
    hasMaxCharacters: (amount, charList) => data => {
        const { HAS_MAX_CHARACTERS_MESSAGE } = MESSAGES;
        let ttl = 0, chars = charList.split('').map(c => ({ _char: c, count: 0 }));

        for(let c in chars) {
            chars[c].count = data.split(chars[c]._char).length - 1;
            ttl += chars[c].count;
        }

        return ttl <= amount ? VALID : getError(HAS_MAX_CHARACTERS_MESSAGE(amount, charList));
    },
    isRegex: (regex, msg) => data => {
        return validator.matches(data, regex) ? VALID : getError(msg);
    }
}


export function getRules(rulesArray) {
    let rules = [];
    for(let i in rulesArray) {
        let rule = rulesArray[i];
        if(validationRules.hasOwnProperty(rule))
            rules.push(validationRules[rule]);
    }
    return rules;
}
